module.exports = __webpack_public_path__ + "static/media/space-bg-square.bf4426de.png";